// extracted by mini-css-extract-plugin
export var container = "_0ET3r";
export var leftCell = "VuLP+";
export var name = "wyBH4";
export var photo = "poiKS";
export var proBadge = "voRGc";
export var review = "SAZcz";
export var star = "bzYLY";